import axios from 'axios';
import { authHeader } from '../utils/tokenUtils';

const BASE_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8080'}/api/nav-menus`;

export const getActiveNavMenus = () => axios.get(BASE_URL);
export const getAllNavMenus = () => axios.get(`${BASE_URL}/admin/all`, authHeader());
export const createNavMenu = (data) => axios.post(BASE_URL, data, authHeader());
export const updateNavMenu = (id, data) => axios.put(`${BASE_URL}/${id}`, data, authHeader());
export const deleteNavMenu = (id) => axios.delete(`${BASE_URL}/${id}`, authHeader());